import React, { Fragment } from 'react';
import { Popup } from 'semantic-ui-react';

const HelpIcon = (props) => {
  const { content } = props;

  return (
    <Fragment>
      <Popup content={content} trigger={<i className='fal fa-question-circle fa-lg' style={{ color: '#fab742', marginLeft: '5px' }} />} />
    </Fragment>
  );
};

export default HelpIcon;



// WEBPACK FOOTER //
// ./src/components/common/helpIcon.js